export type AvatarPart = {
  id: string,
  name: string,
  count: number,
}

export const PARTS: AvatarPart[] = [
  {
    id: "face",
    name: "Face",
    count: 16,
  },
  {
    id: "nose",
    name: "Nose",
    count: 14,
  },
  {
    id: "mouth",
    name: "Mouth",
    count: 20,
  },
  {
    id: "eyes",
    name: "Eyes",
    count: 14,
  },
  {
    id: "eyebrows",
    name: "Eyebrows",
    count: 16,
  },
  {
    id: "glasses",
    name: "Glasses",
    count: 15,
  },
  {
    id: "hair",
    name: "Hair",
    count: 59,
  },
  {
    id: "accessories",
    name: "Accessories",
    count: 15,
  },
  {
    id: "details",
    name: "Details",
    count: 14,
  },
  {
    id: "beard",
    name: "Beard",
    count: 17,
  },
];
